export default __webpack_public_path__ + "static/media/ranjhana.6af5be10.jfif";